'use client';

import { VStack } from '@terra/ui-styled-system';
import { SettingsNavItem } from './SettingsNavItem';
import type { SettingsNavItemConfig } from './types';

type SettingsContextNavProps = {
  items: SettingsNavItemConfig[];
  value: string;
  onValueChange: (value: string) => void;
};

export function SettingsContextNav({
  items,
  value,
  onValueChange,
}: SettingsContextNavProps) {
  return (
    <VStack alignItems="stretch" gap={1} w="full">
      {items.map((item) => (
        <SettingsNavItem
          key={item.value}
          {...item}
          selected={item.value === value}
          onSelect={onValueChange}
        />
      ))}
    </VStack>
  );
}
